import { http } from "./utils/fetch"
import { Image } from 'react-native';

export const proposalmain = {
    state: {
        loading: true,
        data: {},
        error: null
    },
    reducers: {
        setMainInfo(state, payload) {
            return {
                data: payload,
                loading: false,
                error: null
            }
        },
        setError(state, payload) {
            return {
                ...state,
                loading: false,
                error: payload
            }
        },
        setLoading(state) {
            return {
                ...state,
                loading: true,
                error: null
            }
        },
    },
    effects: dispatch => ({
        async fetchInfo(mainToken, receiver_id) {
            try {
                dispatch.proposalmain.setLoading();

                const { data } = await http.get(mainToken, { receiver_id: receiver_id });

                if (data?.list) {
                    data.list.forEach(estate => {
                        if (estate.photos) {
                            estate.photos.forEach(photo => Image.prefetch(photo))
                        }
                    });
                }

                dispatch.proposalmain.setMainInfo(data)
            } catch (e) {
                dispatch.proposalmain.setError(e.type || 'server')
            }
        },
    }),
}
